export const FUEL_DISCOVERY_KEY = "kiloprice.fuel-visited.v1";

/** Monotonic account hint with a device-local fallback; never stores location. */
export class FuelDiscovery {
  private visited = false;
  private ready: boolean;
  constructor(private readonly storage: { read(): string | null; write(): void }, ready = false) {
    this.ready = ready;
    try { this.visited = storage.read() === "1"; } catch { /* Memory/cloud still work. */ }
  }
  get seen(): boolean { return this.visited; }
  get highlight(): boolean { return this.ready && !this.visited; }
  hydrate(visited: boolean): void {
    this.ready = true;
    if (visited) this.opened(); // A stale response must never restore the cue.
  }
  opened(): boolean {
    if (this.visited) return false;
    this.visited = true;
    try { this.storage.write(); } catch { /* Existing sync queue retains the change. */ }
    return true;
  }
}
